import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { docUpdate } from "../../API/DocUpdate";
import { formatDateForStorage } from "./DateManager"; 
import { updateInstanceData } from "../../API/UpdateInstance";
import { updateInstanceDataADM } from "../../AdminAPI/UpdateInstanceADM";
import "../Dashboard/Default/TabLots/LotsTable.css";
import "react-datepicker/dist/react-datepicker.css";
import i18n from "../../Langues/i18n";

export const handleSubmitChange = async (DocId, data, instanceId) => {
  const updatedItem = data.find((item) => item.DocId === DocId);
  if (updatedItem) {
    const { Complexite, Priorite, isvalid } = updatedItem;
    const idToken = Cookies.get("Token");
    const newstatus = isvalid == false ? "invalid" : "qualified";

    console.log("Mise à jour avec les paramètres :", {
      idToken,
      instanceId,
      DocId,
      Complexite,
      Priorite,
      isvalid,
      newstatus,
    });

    try {
      const response = await docUpdate(
        idToken,
        instanceId,
        DocId,
        Complexite,
        Priorite,
        isvalid,
        newstatus
      );
    } catch (error) {
      console.error("Erreur lors de la mise à jour des données", error);
    }
  }
};

export const handleUpdateSelected = async (selectedDocuments, data, instanceId, setSelectedDocuments) => {
  var errcount = 0;
  for (const DocId of selectedDocuments) {
    try {
      await handleSubmitChange(DocId, data, instanceId);
    } catch (error) {
      errcount++;
    }
  }

  if (errcount !== 0) {
    toast.error(
      i18n.t(
        "Error updating documents. {{errcount}} document(s) could not be updated.",
        { errcount }
      ),
      {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  } else {
    toast.success(i18n.t("Data updated successfully!"), {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSelectedDocuments([]);
    window.location.reload();
  }
};

export const handleInputChange = (event, DocId, key, data, setData, setSelectedDocuments) => {
  const { value, type, checked } = event.target;
  
  if (type === "checkbox") {
    if (checked) {
      setSelectedDocuments((prevSelected) => [...prevSelected, DocId]);
    } else {
      setSelectedDocuments((prevSelected) =>
        prevSelected.filter((id) => id !== DocId)
      );
    }
  } else {
    const newValue =
      key === "isvalid" ? event.target.value === "true" : value;
    const newData = data.map((item) => {
      if (item.DocId === DocId) {
        const updatedItem = { ...item, [key]: newValue };
        const isAnyFieldModified = Object.keys(updatedItem).some(
          (field) => field !== "DocId" && item[field] !== updatedItem[field]
        );
        if (isAnyFieldModified) {
          setSelectedDocuments((prevSelected) => [...prevSelected, DocId]);
        } else {
          setSelectedDocuments((prevSelected) =>
            prevSelected.filter((id) => id !== DocId)
          );
        }
        return updatedItem;
      }
      return item;
    });
    setData(newData);
  }
};


export const handleInputChangeDate = (value, kInstanceId, key, data, setData, handleSubmitChangeInstance) => {
  const newData = data.map((item) => {
    if (item.kInstanceId === kInstanceId) {
      return {
        ...item,
        [key]:
          key === "dDateRemise"
            ? value ? formatDateForStorage(new Date(value)) : ""
            : value,
      };
    }
    return item;
  });
  setData(newData);
  handleSubmitChangeInstance(newData, kInstanceId);
};


export const handleSubmitChangeInstance = async (newData, instanceId) => {
  const role = Cookies.get("Role");
  const updatedItem = newData.find((item) => item.kInstanceId === instanceId);
  if (updatedItem) {
    const { dDateRemise, sStatus, kClientId } = updatedItem; 
    const idToken = Cookies.get("Token");
    let response;
    try {
      if (role === "superadmin"){
        response = await updateInstanceDataADM(idToken,instanceId, sStatus, dDateRemise, kClientId)
      } else {
        response = await updateInstanceData(
          idToken,
          instanceId,
          sStatus,
          dDateRemise
        );
      }
    } catch (error) {
      toast.error(i18n.t("Error updating instance."));
      console.error("Erreur lors de la mise à jour des données", error);
    }
  }
};
